import { Box, styled } from "@mui/system";

export const LeftDrawerContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`;
